const STANDALONE_OVERRIDE_KEY = 'ewert_standalone_override'
const STANDALONE_QUERY_KEYS = ['standalone', 'pwa', 'quickapp']

function matchesDisplayMode(mode) {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia(`(display-mode: ${mode})`).matches
}

function hasStandaloneQuery() {
  if (typeof window === 'undefined') return false

  const params = new URLSearchParams(window.location.search)
  return STANDALONE_QUERY_KEYS.some((key) => {
    const value = params.get(key)
    return value === '1' || value === 'true'
  })
}

export function markStandaloneFromLaunch() {
  if (typeof window === 'undefined') return false

  if (hasStandaloneQuery()) {
    window.localStorage.setItem(STANDALONE_OVERRIDE_KEY, '1')
    return true
  }

  return false
}

export function isStandaloneLaunch() {
  if (typeof window === 'undefined') return false

  markStandaloneFromLaunch()

  const navigatorStandalone = window.navigator && window.navigator.standalone === true
  const displayModeStandalone = matchesDisplayMode('standalone')
    || matchesDisplayMode('fullscreen')
    || matchesDisplayMode('minimal-ui')
  const appReferrer = typeof document !== 'undefined'
    && typeof document.referrer === 'string'
    && document.referrer.startsWith('android-app://')
  const storedOverride = window.localStorage.getItem(STANDALONE_OVERRIDE_KEY) === '1'

  return Boolean(navigatorStandalone || displayModeStandalone || appReferrer || storedOverride)
}

export function getStandaloneDebugInfo() {
  if (typeof window === 'undefined') {
    return { standalone: false }
  }

  return {
    standalone: isStandaloneLaunch(),
    displayStandalone: matchesDisplayMode('standalone'),
    displayFullscreen: matchesDisplayMode('fullscreen'),
    displayMinimalUi: matchesDisplayMode('minimal-ui'),
    navigatorStandalone: window.navigator && window.navigator.standalone === true,
    appReferrer: typeof document !== 'undefined' ? document.referrer : '',
    storedOverride: window.localStorage.getItem(STANDALONE_OVERRIDE_KEY) === '1',
    launchQuery: hasStandaloneQuery(),
    userAgent: window.navigator.userAgent
  }
}
